<template>
  <layout-main-inner
    v-loading="loading"
    showBack>
    <layout-card-wrap>
      <el-descriptions
        title="基础信息"
        size="medium">
        <el-descriptions-item label="委托单号">{{ ruleForm.appraisalNo }}</el-descriptions-item>
        <el-descriptions-item label="外部单号">{{ ruleForm.yhbBizOrderId || '-' }}</el-descriptions-item>
        <el-descriptions-item
          v-if="ruleForm.orderSource === 3"
          label="对接单号">{{ ruleForm.yhbBizOrderId }}</el-descriptions-item>
        <el-descriptions-item label="客户名称">{{ ruleForm.vendorName }}</el-descriptions-item>
        <el-descriptions-item label="委托类型">{{ ruleForm.appraisalType | appraisalTypeName() }}</el-descriptions-item>
        <el-descriptions-item label="委托状态">{{ ruleForm.status | orderStatusName() }}</el-descriptions-item>
        <el-descriptions-item label="品类品牌">{{ ruleForm.categoryName }} / {{ ruleForm.blandName }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ ruleForm.spuName }}</el-descriptions-item>
        <el-descriptions-item label="原产国">{{ ruleForm.originCountryName }}</el-descriptions-item>
        <el-descriptions-item label="唯一识别码">{{ ruleForm.tagNo || ruleForm.certNo }}</el-descriptions-item>
        <template v-if="ruleForm.appraisalType === 2">
          <el-descriptions-item label="溯源码">{{ ruleForm.zsTagCode }}</el-descriptions-item>
        </template>
        <el-descriptions-item label="商品估值">{{ ruleForm.goodsPrice }}元</el-descriptions-item>
        <el-descriptions-item label="费用">{{ ruleForm.appraisalFee }}元</el-descriptions-item>
        <el-descriptions-item label="联系信息">{{ ruleForm.vendorName }}-{{ ruleForm.vendorPerson }}-{{ ruleForm.vendorPhone }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        title="图文信息"
        size="medium">
        <el-descriptions-item
          label="商品图片"
          :span="3">
          <image-list :list="ruleForm.spuImages" />
        </el-descriptions-item>
        <template v-if="ruleForm.orderSource === 2 || ruleForm.orderSource === 3">
          <el-descriptions-item
            label="细节图片"
            :span="3">
            <image-list :list="ruleForm.detailImages" />
          </el-descriptions-item>
          <el-descriptions-item label="使用状态">{{ ruleForm.goodsUseStatus | getUserStatusName() }}</el-descriptions-item>
          <el-descriptions-item label="细节描述">{{ ruleForm.appraisalFee }}</el-descriptions-item>
        </template>
      </el-descriptions>

      <el-descriptions
        title="物流信息"
        size="medium">
        <el-descriptions-item label="发件物流单号">{{ ruleForm.senderCourierNumber }}</el-descriptions-item>
        <el-descriptions-item label="发件信息">
          <div>{{ ruleForm.senderProvName }}{{ ruleForm.senderCityName }}{{ ruleForm.senderAreaName }}{{ ruleForm.senderAddress }}</div>
          <div style="color:#777">
            <span>{{ ruleForm.senderName }}</span>
            <span style="margin-left:10px">{{ ruleForm.senderPhone }}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="回寄物流单号">
          <div>{{ ruleForm.appraisalDeliveryCourierNumber }}</div>
          <div v-if="ruleForm.appraisalDeliveryCourierNumber2">
            <el-tag
              effect="dark"
              size="mini">新</el-tag>
            <span> {{ ruleForm.appraisalDeliveryCourierNumber2 }}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="收件信息">
          <div>{{ ruleForm.receiverProvName }}{{ ruleForm.receiverCityName }}{{ ruleForm.receiverAreaName }}{{ ruleForm.receiverAddress }}</div>
          <div style="color:#777">
            <span>{{ ruleForm.receiverName }}</span>
            <span style="margin-left:10px">{{ ruleForm.receiverPhone }}</span>
            <el-tag>{{ ruleForm.receiverType === 1 ? '退回卖家': '发货买家' }}</el-tag>
          </div>
        </el-descriptions-item>
        <template v-if="ruleForm.orderSource === 2 && ruleForm.receiverType === 1 && ruleForm.yhbOrderVersion === 'V3' && ruleForm.status >= 10">
          <el-descriptions-item label="卖家支付状态">{{ ruleForm.yhb3BillState }}</el-descriptions-item>
          <el-descriptions-item label="纠纷单状态">{{ ruleForm.yhb3DisputeState }}</el-descriptions-item>
          <el-descriptions-item label="在库天数">{{ ruleForm.delivery2SellerDays }}天</el-descriptions-item>
        </template>
      </el-descriptions>

      <!-- <el-descriptions
        title="鉴定信息"
        size="medium">
        <el-descriptions-item
          label="鉴定流程"
          :span="3">
          <el-form class="form-mb-0">
            <el-tabs
              v-model="avtive"
              type="border-card">
              <el-tab-pane
                label="客户提供"
                name="1">
                <appraisal-item :list="ruleForm.originalAppraisalItems" />
              </el-tab-pane>
              <el-tab-pane
                v-if="ruleForm.firstAppraisalItems"
                label="初审鉴定"
                name="2">
                <appraisal-item :list="ruleForm.firstAppraisalItems" />
                <el-form-item label="鉴定结果：">{{ ruleForm.firstAppraisalResult | appraisalResultName() }}</el-form-item>
                <el-form-item label="鉴定结论：">{{ ruleForm.firstAppraisalMemo }}</el-form-item>
                <el-form-item label="鉴定师：">{{ ruleForm.firstAppraisalUserName }}</el-form-item>
              </el-tab-pane>
              <el-tab-pane
                v-if="ruleForm.secondAppraisalItems"
                label="初审2鉴定"
                name="3">
                <appraisal-item :list="ruleForm.secondAppraisalItems" />
                <el-form-item label="鉴定结果：">{{ ruleForm.secondAppraisalResult | appraisalResultName() }}</el-form-item>
                <el-form-item label="鉴定结论：">{{ ruleForm.secondAppraisalMemo }}</el-form-item>
                <el-form-item label="鉴定师：">{{ ruleForm.secondAppraisalUserName }}</el-form-item>
              </el-tab-pane>
              <el-tab-pane
                v-if="ruleForm.thirdAppraisalItems"
                label="初审3鉴定"
                name="4">
                <appraisal-item :list="ruleForm.thirdAppraisalItems" />
                <el-form-item label="鉴定结果：">{{ ruleForm.thirdAppraisalResult | appraisalResultName() }}</el-form-item>
                <el-form-item label="鉴定结论：">{{ ruleForm.thirdAppraisalMemo }}</el-form-item>
                <el-form-item label="鉴定师：">{{ ruleForm.thirdAppraisalUserName }}</el-form-item>
              </el-tab-pane>
              <el-tab-pane
                v-if="ruleForm.appraisalAckItems"
                label="复审鉴定"
                name="5">
                <appraisal-item :list="ruleForm.appraisalAckItems" />
                <el-form-item label="鉴定结果：">{{ ruleForm.appraisalAckResult | appraisalResultName() }}</el-form-item>
                <el-form-item label="鉴定结论：">{{ ruleForm.appraisalAckMemo }}</el-form-item>
                <el-form-item label="鉴定师：">{{ ruleForm.appraisalAckUserName }}</el-form-item>
              </el-tab-pane>
              <el-tab-pane
                v-if="ruleForm.appraisalReviewItems"
                label="审核鉴定"
                name="6">
                <appraisal-item :list="ruleForm.appraisalReviewItems" />
                <el-form-item label="鉴定结果：">{{ ruleForm.appraisalReviewResult | appraisalResultName() }}</el-form-item>
                <el-form-item label="鉴定结论：">{{ ruleForm.appraisalReviewMemo }}</el-form-item>
                <el-form-item label="鉴定师：">{{ ruleForm.appraisalReviewUserName }}</el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </el-descriptions-item>
        <el-descriptions-item
          label="校对人员"
          :span="3">{{ ruleForm.appraisalCheckUserName }}</el-descriptions-item>
        <el-descriptions-item
          label="鉴定结果"
          :span="3">{{ ruleForm.appraisalResult | appraisalResultName() }}</el-descriptions-item>
        <el-descriptions-item
          label="鉴定结论"
          :span="3">{{ ruleForm.appraisalMemo }}</el-descriptions-item>
        <el-descriptions-item
          label="时间轴"
          :span="3">
          <el-steps
            direction="vertical"
            :active="timeLine.length">
            <el-step
              v-for="(item, index) in timeLine"
              :key="index"
              :title="item.label"
              :description="item.time | dateformat()"></el-step>
          </el-steps>
        </el-descriptions-item>
      </el-descriptions> -->
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import ImageList from '@/components/image-list.vue'
// import AppraisalItem from './busi/appraisal-item.vue'
import { getTimeLine } from './index'
import CustomApi from '@/service/custom'
export default {
  name: 'OrderDetail',
  components: { ImageList },
  data() {
    return { avtive: '1', loading: true, ruleForm: { spuImages: [], detailImages: [] }, timeLine: [] }
  },
  mounted() {
    this.fetchInfo()
  },
  methods: {
    fetchInfo() {
      this.loading = true
      CustomApi.getappraisalorder({ ...this.$route.query })
        .then(res => {
          this.loading = false
          const { result, message, spuImages, detailImages } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', { ...res.data, spuImages: this.$splitImage(spuImages), detailImages: this.$splitImage(detailImages) })
            this.timeLine = getTimeLine(res.data)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
